module.exports = __webpack_public_path__ + "img/app_download.9eed6fdc.png";